// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__v9FKw","headerLink":"header_headerLink__2q6NL","logo":"header_logo__1X7aW"};